<template>
  <div class="user-manage-container">
    <div class="search-bar">
      <input type="text" placeholder="用户ID：请输入用户ID" v-model="searchUserId" />
      <input type="text" placeholder="用户：昵称/姓名/手机号" v-model="searchUserName" />
      <button class="search-button" @click="search">搜索</button>
      <button class="clear-button" @click="clear">清空</button>
      <button class="import-button" @click="openFileInput">导入通讯录</button>
      <input
        ref="fileInput"
        type="file"
        accept=".xlsx"
        @change="uploadFile"
        style="display: none"
      />
      <a style="float: right; padding: 5px;" href="https://fk2.h3166.work/导入参考文档.docx" download class="download-link">
        <el-button type="primary">下载导入参考文档</el-button>
      </a>
    </div>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>用户名</th>
          <th>是否管理员</th>
          <th>部门</th>
          <th>真实姓名</th>
          <th>手机号</th>
          <th>邮箱</th>
          <th>余额</th>
          <th>状态</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in filteredUsers" :key="user.id">
          <td>{{ user.id }}</td>
          <td>{{ user.userName }}</td>
          <td>{{ user.isAdmin }}</td>
          <td>{{ user.department }}</td>
          <td>{{ user.name }}</td>
          <td>{{ user.phone }}</td>
          <td>{{ user.mail }}</td>
          <td>{{ user.money }}</td>
          <td>{{ user.zhuangtai }}</td>
          <td>
            <button class="adjust-button" @click="openAdjustBalanceModal(user.id)">调整余额</button>
            <button class="clear-button" @click="openClearBalanceModal(user.id)">清零余额</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 调整余额模态框 -->
    <div v-if="showAdjustBalanceModal" class="modal-overlay">
      <div class="modal">
        <h3>调整余额</h3>
        <input type="number" v-model="adjustAmount" placeholder="请输入金额" />
        <button class="confirm-button" @click="adjustBalanceConfirm">确定</button>
        <button class="cancel-button" @click="closeAdjustBalanceModal">取消</button>
      </div>
    </div>

    <!-- 清空余额模态框 -->
    <div v-if="showClearBalanceModal" class="modal-overlay">
      <div class="modal">
        <h3>清空余额</h3>
        <p>确定要清空余额吗？</p>
        <button class="confirm-button" @click="clearBalanceConfirm">确定</button>
        <button class="cancel-button" @click="closeClearBalanceModal">取消</button>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  data() {
    return {
      searchUserId: '',
      searchUserName: '',
      users: [],
      showAdjustBalanceModal: false,
      showClearBalanceModal: false,
      adjustAmount: null,
      currentUserId: null
    };
  },
  computed: {
    filteredUsers() {
      return this.users.filter(user => {
        const matchesUserId = this.searchUserId ? user.id.toString().includes(this.searchUserId) : true;
        const matchesUserName = this.searchUserName ? user.name.includes(this.searchUserName) || user.userName.includes(this.searchUserName) || user.phone.includes(this.searchUserName) : true;
        return matchesUserId && matchesUserName;
      });
    }
  },
  methods: {
    async fetchUsers() {
      try {
        const response = await this.$axios.get('/api/show_tongxunlu');
        const data = response.data;
        if (data.code === 0) {
          this.users = data.data;
        } else {
          console.error('Failed to fetch users:', data.message);
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    },
    search() {
      // 搜索逻辑已经在 computed 属性中实现
    },
    clear() {
      this.searchUserId = '';
      this.searchUserName = '';
    },
    openAdjustBalanceModal(userId) {
      this.showAdjustBalanceModal = true;
      this.currentUserId = userId;
    },
    closeAdjustBalanceModal() {
      this.showAdjustBalanceModal = false;
      this.adjustAmount = null;
    },
    async adjustBalanceConfirm() {
      if (this.adjustAmount !== null) {
        try {
          const response = await this.$axios.post('/api/change_yuer', {
            id: this.currentUserId,
            lastMoney: this.currentUser.money, // 调整前的余额
            money: this.adjustAmount
          });
          const data = response.data;
          if (data.code === 0) {
            this.$message.success({
            message: '余额调整成功',
            duration: 2000
          });
            this.closeAdjustBalanceModal();
            this.fetchUsers(); // 刷新用户列表
          } else {
            this.$message.error({
            message: '余额调整失败',
            duration: 2000
          });
          }
        } catch (error) {
          console.error('Error adjusting balance:', error);
        }
      } else {
        this.$message.error({
            message: '请输入有效的金额',
            duration: 2000
          });
      }
    },
    openClearBalanceModal(userId) {
      this.showClearBalanceModal = true;
      this.currentUserId = userId;
    },
    closeClearBalanceModal() {
      this.showClearBalanceModal = false;
    },
    async clearBalanceConfirm() {
      try {
        const response = await this.$axios.post('/api/change_zero_yuer', {
          id: this.currentUser.id,
          lastMoney: this.currentUser.money, // 调整前的余额
          money: 0 // 清空余额
        });
        const data = response.data;
        if (data.code === 0) {
          this.$message.success({
            message: '余额已清空',
            duration: 2000
          });
          this.closeClearBalanceModal();
          this.fetchUsers(); // 刷新用户列表
        } else {
          this.$message.error({
            message: '清空余额失败',
            duration: 2000
          });
        }
      } catch (error) {
        console.error('Error clearing balance:', error);
      }
    },
    openFileInput() {
      this.$refs.fileInput.click(); // 触发文件选择器
    },
    async uploadFile(event) {
      const file = event.target.files[0];
      if (!file) {
        this.$message.warning({
            message: '请选择一个文件',
            duration: 2000
          });
        return;
      }

      if (!file.name.endsWith('.xlsx')) {
        this.$message.error({
            message: '只支持上传 .xlsx 格式的文件',
            duration: 2000
          });
        return;
      }

      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await this.$axios.post('/api/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        const data = response.data;
        if (data.code === 0) {
          this.$message.success({
            message: '通讯录导入成功',
            duration: 2000
          });
          this.fetchUsers(); // 刷新用户列表
        } else {
          this.$message.error({
            message: '导入失败',
            duration: 2000
          });
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        this.$message.error({
            message: '导入失败: 服务器错误',
            duration: 2000
          });
      }
    }
  },
  mounted() {
    this.fetchUsers();
  }
};
</script>
<style scoped>
.user-manage-container {
  padding: 20px;
  font-size: 12px;
}

.search-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.search-bar input,
.search-bar select,
.search-bar button {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.import-button {
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ccc;
  padding: 5px;
  text-align: left;
}

.adjust-button {
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.clear-button {
  background-color: #ff9800;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.search-button {
  background-color: #4caf50;
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal h3 {
  margin-top: 0;
  margin-bottom: 10px;
}

.modal input {
  width: 100%;
  margin-bottom: 10px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.confirm-button {
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

.cancel-button {
  background-color: #ff9800;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>